module.exports = __webpack_public_path__ + "img/icon_map_13_off_110.969724c5.png";